exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marginer[data-v-07b4c1d4]{margin:30px}.items-row[data-v-07b4c1d4]{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap}.black-left[data-v-07b4c1d4]{border-left:1px solid #000}.main-content[data-v-07b4c1d4]{width:600px}.codebox[data-v-07b4c1d4]{border:1px solid grey;width:100%;overflow:auto;height:350px;outline:none;font-size:17px}.yoearth-item[data-v-07b4c1d4]{border-top:1px solid #000;margin-bottom:20px}", ""]);

// exports
